
import LayoutContent from '../../components/layouts/content2';
import React, { useEffect, useState } from 'react';
import { useLocation } from 'react-router-dom';
import { getImage, getData } from '../../helpers/indexedDbHelper';
import { Link } from 'react-router-dom';
import {useTranslation} from 'react-i18next';
import translate from '../../helpers/translate';
import translateMenu from '../../helpers/translateMenu';
import DetailProduct from './DetailProduct';
import SpecialsScreen from './specials';
import CategoriesScreen from './categories';
import ListProducts from './ListProducts';
import { useRefresh } from '../../hooks/useRefresh';


function Index({dishs, setShowListProduct, goHome}) { 

    const {i18n} = useTranslation();
    const langEng = i18n.language === 'en' ?? false;
    const { change } = useRefresh();
    
    const { menus, name: title } = dishs;

    const [showSpecials, setShowSpecials] = useState(false);

    const [showCategories, setshowCategories] = useState(false);
    
    const [titleCategorie, setIitleCategorie] = useState('');
    const [showListProduct, setShowListProduct2] = useState(false);

    const [showDetailProduct, setShowDetailProduct] = useState(false);
    const [dataDish, setDataDish] = useState(false);
    const [drinks, setdrinks] = useState(false);
    const [dishsdata, setdishs] = useState(false);
    const [menusData, setMenusData] = useState([]);
    

      
        useEffect(() => {
            getData('menu').then((items) => {
                const data = items.value.data;
               
                setMenusData(data);
            });
        }, [change]);
    
    
    useEffect(() => {
        if (menus) {
           
            
            setIitleCategorie(langEng ? 
                dishs.name
                :    
                translate(i18n.language, dishs.language, dishs.name)
            )
        }
    }, [menus]);


     const [dataDrink, setdataDrink] = useState(false);
       useEffect(() => {
                menus.map((item) => {
                    if (item.id === 479) {
                        setdrinks(item);
                        
                    }
                });
          }, [menus]);
        
    
         useEffect(() => {
             if (drinks) {
                 drinks.menus.map((item) => {
                     if (item.id === 4374) {
                         setdataDrink(item)
                         
                    
                   }
               })
           }
         }, [drinks]);
         


        
              useEffect(() => {
                    menusData.map((item) => {
                        if (item.id === 479) {
                            console.log('drink', item)
                            setdrinks(item);
                        }
                    });
              }, [menusData]);
    


    const fetchImage = async (id) => {
        const imageBlob = await getImage(id);
        if (imageBlob) {
            const imageURL = URL.createObjectURL(imageBlob.data.blob);
            return imageURL;
        }
        return null;
    };


    const Item = ({ data }) => {
        const [image, setImage] = useState(false);
        useEffect(() => {
            fetchImage(`menu-image-${data.id}`).then((url) => {
                if (url) {
                    setImage(url);
                    
                }
            });
        }, []);
        
        return (
           <div onClick={()=>[setShowDetailProduct(true), setDataDish({ dish: data, alldish: menus, currentDish: dishs })]}  style={{
                backgroundColor: 'white', marginBottom: 30, textDecoration: 'none', 
                width: 330,
                height: 440,
                margin: '15px 0px',
                textAlign: 'left',
                paddingBottom: 40,
                position: 'relative',
                borderRadius: 30,
              
                boxSizing: "border-box",
                display: 'flex',
                flexDirection: 'column',
                background: 'white'
            }}>
                <img src={image}  style={{width: '100%', height: 280, objectFit: 'cover',  borderRadius: 30, marginBottom: 10}}/>
                <h3 style={
                    { fontFamily: "LondrinaSolidRegular", color: 'black', textTransform: 'uppercase', fontSize: 22, fontWeight: '500',margin: 0, textAlign: 'center' }
                    }> {langEng ? data.name : translate(i18n.language, data.language, data.name)}</h3>
                
                <div style={{width: '80%', margin: '0 auto',}}>
                    <p
                        className='shor-text'
                        style={{ fontFamily: "LondrinaSolidLight",fontSize: 15, color: 'black', textAlign: 'center', margin: 0,}}>

                        {langEng ? 
                                    `${data.regular_decription.replace(/\\n/g,'\n')}`
                                : 
                                `${translateMenu(
                                    i18n.language, 
                                    data.language, 
                                    data.regular_decription, 
                                    'regular_decription'
                                )}`
                        }
                        
                    </p>
                </div>
                <div style={{
                    width: '100%',
                    height: 20,
                        alignSelf: 'center',
                        backgroundColor: '#3D0047',
                        padding: '15px 0px',
                        marginTop: 20,
                        margin: '0 auto',
                        borderRadius:10,
                        position: 'absolute',
                        bottom: 0,
                        display: 'flex',
                        alignItems: 'center',
                        justifyContent: "center"
                        
                }}>
                <p
                    style={
                        {
                        color:'#fff',
                        fontSize: 18,
                        fontWeight: 'bold',
                                textAlign: 'center',
                       
                        }
                    }>
                       
                            <>
                            {data.price > 0
                                ? `${data.label_price ?? ''} $${data.price.toFixed(2)}`
                            : 'Market Price'}
                            </>
                       
                    </p>
                </div>
                
                
            </div>
        );
    }

    return (
        <div style={{position: 'absolute', top: 0, left: 0, width: '100%', height: '100%', zIndex: 9999}}>
            <LayoutContent goCategories={setshowCategories} showBack={true} goHome={goHome} setShowListProduct={setShowListProduct}  setShowSpecials={() => {
             setShowSpecials(true)
        }}>
                <div >

                       <div style={{  }} onClick={() => {
                                setDataDish({ dish: dataDrink, alldish: drinks.menus})
                                setShowDetailProduct(true)
                            }}>
                        
                        </div>
                    <div style={{
                        marginTop: 1,
                            display: 'flex',
                            flexWrap: 'wrap',
                            justifyContent: 'space-between',
                            padding: '0px 20px 100px 20px',
                              height: 680,
                            overflow: 'scroll',
                            
                        }}>
                            {menus.map((item, key) => (
                                <Item data={ item }  key={key} />
                            ))}
                    </div>   
                    
      

                
                
                </div>

                 {showListProduct && <ListProducts
                                    dishs={dishsdata}
                                    setShowListProduct={setShowListProduct2}
                                    goHome={setshowCategories}
                />}
                
                {showCategories && <CategoriesScreen setshowCategories={setshowCategories} />}
                
                {showDetailProduct && <DetailProduct
                    dishMenu={dataDish}
                    setShowListProduct2={setShowListProduct}
                    setShowDetailProduct={setShowDetailProduct}
                />}

                {showSpecials && <SpecialsScreen setShowListProduct={setShowSpecials} setShowHappy={goHome} />}
                
            </LayoutContent>
        </div>
    );
}
export default Index;